import { Settings as SettingsIcon } from 'lucide-react';
import { QueueSlotsEditor } from '../components/QueueSlotsEditor';

export function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><SettingsIcon size={22} className="text-brand-600" /> Configuración</h1>
        <p className="mt-1 text-sm text-slate-500">Gestiona los ajustes de tu cuenta.</p>
      </div>
      <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
        <h2 className="text-lg font-semibold text-slate-900">Cola de publicación</h2>
        <p className="mt-1 text-sm text-slate-500 mb-5">
          Configura los horarios en los que se publicarán automáticamente las publicaciones que añadas a la cola.
        </p>
        <QueueSlotsEditor />
      </section>
    </div>
  );
}
